import type React from 'react';
import { Alert, Button, TextLink } from '@shared/components';

interface QuoteLoadFailureProps {
    /** React Query's refetch for the quote request. Optional: the failure state
     *  is still correct without a retry affordance. */
    onRetry?: () => void;
}

/** Copy is deliberately non-disclosing: the backend 404s both for a deleted
 *  quote and one outside the caller's scope, and this must not leak which. */
export const QuoteLoadFailure: React.FC<QuoteLoadFailureProps> = ({ onRetry }) => (
    <div className="min-h-screen bg-mp-background flex items-center justify-center p-4">
        <div className="w-full max-w-md">
            <Alert variant="error">
                <div className="flex flex-col items-start gap-2">
                    <p className="font-medium">Quote not found</p>
                    <p>
                        This quote could not be loaded. It may have been removed, or you may not
                        have access to it.
                    </p>
                    <div className="flex items-center gap-4 pt-1">
                        {onRetry && (
                            <Button type="button" size="xs" variant="outline" onClick={() => onRetry()}>
                                Try again
                            </Button>
                        )}
                        <TextLink to="/agreements" color="secondary" className="text-sm">
                            Back to Agreements
                        </TextLink>
                    </div>
                </div>
            </Alert>
        </div>
    </div>
);
